import { groupBy, sum } from "@omnia/shared/utils/array"
import { Cropping } from "../../types"
import { CroppingGroup, Grouping } from "./types"
import { appendAreaHa } from "@omnia/shared/utils/format"

export const groupings: Grouping[] = [

    {
        key: "none",
        name: "All crops",
        grouping: getGroupingFunction(c => ({
            key: "*",
            label: "All crops",
        }))
    },

    {
        key: "crop",
        name: "Group by crop",
        grouping: getGroupingFunction(
            c => ({
                key: `${c.cropId}:${c.cropName}`,
                label: c.cropName,
                cropId: c.cropId
            }),
            c => getCroppingDescription(c, { crop: false, variety: true })
        )
    },

    {
        key: "variety",
        name: "Group by variety",
        grouping: getGroupingFunction(
            c => ({
                key: `${c.cropId}:${c.cropName}:${c.varietyName}`,
                label: [c.cropName, c.varietyName].filter(l => !!l).join(" - "),
                cropId: c.cropId
            }),
            c => getCroppingDescription(c, { crop: false, variety: false })
        )
    },

    {
        key: "fieldGroup",
        name: "Group by field group",
        grouping: getGroupingFunction(c => ({
            key: c.fieldGroup ?? "",
            label: c.fieldGroup ?? "(No field group)",
        }))
    },

    {
        key: "cropDescription",
        name: "Group by crop description",
        grouping: getGroupingFunction(c => ({
            key: c.cropDescription ?? "",
            label: c.cropDescription ?? "(No crop description)",
        }))
    }



] as const

interface GroupKey {
    key: string
    label: string
    cropId?: number
}

function getGroupingFunction(keySelector: (cropping: Cropping) => GroupKey, descriptionSelector?: (cropping: Cropping) => string) {

    return function group(cropping: Cropping[]): CroppingGroup[] {

        cropping ??= []

        const groups = groupBy(cropping, keySelector, k => k.key)

        return groups
            .sort((a, b) => {
                let o = (a.key.cropId || 99999) - (b.key.cropId || 99999)
                o ||= a.key.label.localeCompare(b.key.label)
                return o
            })
            .map(k => ({
                label: k.key.label,
                cropId: k.key.cropId,
                totalArea: Math.round(100 * sum(k.values, v => v.area)) / 100,
                cropping: descriptionSelector
                    ? k.values.map(c => ({
                        ...c,
                        description: descriptionSelector(c)
                    }))
                    : k.values
            }))
    }

}

function getCroppingDescription(cropping: Cropping, { crop, variety }: { crop: boolean, variety: boolean } = { crop: true, variety: true }) {

    let name = [
        cropping.fieldName,
        crop ? cropping.cropName : undefined,
        variety ? cropping.varietyName : undefined
    ].filter(p => Boolean(p)).join(" / ")

    name = appendAreaHa(name, cropping.area)

    return name

}